"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSBorderSection = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var BDSBorderSection_style_1 = require("./BDSBorderSection.style");
var BDSBorderSection = function (_a) {
    var children = _a.children, _b = _a.addHoverCss, addHoverCss = _b === void 0 ? false : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
    return (jsx_runtime_1.jsx(BDSBorderSection_style_1.StyledBorderSection, tslib_1.__assign({ className: "border-section-style-component", addHoverCss: addHoverCss, style: style }, { children: children }), void 0));
};
exports.BDSBorderSection = BDSBorderSection;
